
module.exports = function (app) {
  app.registerComponent('cookie-bar', '.js-cookie-bar', function (sb, el) {

    let cookieName = 'cultuurprijs_cookie_consent'
    let elConfirmCookies = el.querySelector('.js-cookies-confirm')
  
    let showCookieBar = () => {
      el.classList.add('is-visible')
    }
  
    let hideCookieBar = () => {
      el.classList.remove('is-visible')
    }
  
    let checkCookie = () => {
      let hasCookie = getCookie(cookieName)
      if (!hasCookie) showCookieBar()
      return hasCookie
    }
  
    let acceptCookies = () => {
      setCookie(cookieName, true, 365)
      hideCookieBar()
    }
  
    let onClick = (ev) => {
      ev.preventDefault()
      acceptCookies()
    }
  
    let getCookie = (cname) => {
      var name = cname + '='
      var ca = window.document.cookie.split(';')
  
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    }
  
    let setCookie = (cname, value, exdays, cb) => {
      var ex = new Date()
      ex.setDate(ex.getDate() + exdays)
  
      var cvalue = escape(value) + (exdays === null ? '' : '; expires=' + ex.toUTCString() + '; path=/;')
  
      window.document.cookie = cname + '=' + cvalue
    }
  
    return {
      init: function() {
        console.log('aio')
        if (elConfirmCookies) {
          if (!checkCookie()) elConfirmCookies.addEventListener('click', onClick)
        }
      },
      destroy: function() {
        if (elConfirmCookies) elConfirmCookies.removeEventListener('click', onClick)
      }
    }
  })
};





// WEBPACK FOOTER //
// ./assets/js/components/cookie-bar.js